import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UrlService} from '@shared/services/url.service';
import {Observable} from 'rxjs';
import {API_ENTITY_LOAN_TRANSACTIONS, API_ENTITY_LOANS} from '../../../config/urls';
import {EntityLoanListDto} from '@dto/holdings/entity-loan-list.dto';
import {EntityLoanTransactionListDto} from "@dto/holdings/entity-loan-transaction-list.dto";

@Injectable({
  providedIn: 'root'
})
export class EntityLoanService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getEntityLoans(entityCode: string): Observable<EntityLoanListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_LOANS, entityCode);
    return this.http.get<EntityLoanListDto>(endpointUrl);
  }

  public getEntityLoanTransactions(entityCode: string, entityLoanId: string): Observable<EntityLoanTransactionListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_LOAN_TRANSACTIONS, entityCode, entityLoanId);
    return this.http.get<EntityLoanTransactionListDto>(endpointUrl);
  }
}
